<template>
   <div class="row bgc-wrapper margin-top-42">
    <div class="col-lg-12 col-md-12 col-sm-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id = "pin_dam_det_update"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#PinDamageDetailUpdate"
          >
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Pin Damage Detail</h3>
      </div>
    </div>
    <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="PinDamageDetailUpdate">
      <div class="row d-flex">
        <!--Pre Inspection Number* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="pinDamageDetailUpdateData.preInspectionNo.visibility">
          <div class="row form-group">
              <float-label label="Pre Inspection Number*" :fixed="isFloat(pinDamageDetailUpdateData.preInspectionNo.value)"> 
                <input
                  v-model="pinDamageDetailUpdateData.preInspectionNo.value"
                  v-evolvews="pinDamageDetailUpdateData.preInspectionNo"
                  type="text"
                  :class="{'bgc-error-field':pinDamageDetailUpdateData.preInspectionNo.errorText !== ''}"
                  class="form-control"
                  placeholder="Pre Inspection Number*"
                />
              </float-label>
              <span class="error-text" v-if="pinDamageDetailUpdateData.preInspectionNo.errorText !== ''">
                {{pinDamageDetailUpdateData.preInspectionNo.errorText}}</span>
          </div>
        </div>
        <!--Pre Inspection Number* ends-->
        <!--Get PIN* starts-->
        <button id="get_pin_pin_damage" class="bgc-btn-primary mr-4 mt-4" type="button">Get PIN</button>
        <!--Get PIN* ends-->
      </div>
      <div class="row">
        <!--Pin Damage Details* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="pinDamageDetailUpdateData.pinDamageDetails.visibility">
            <div class="row form-group">
                <float-label label="Pin Damage Details*" :fixed="isFloat(pinDamageDetailUpdateData.pinDamageDetails.value)"> 
                    <input
                      v-model="pinDamageDetailUpdateData.pinDamageDetails.value"
                      v-evolvews="pinDamageDetailUpdateData.pinDamageDetails"
                      type="text"
                      :class="{'bgc-error-field':pinDamageDetailUpdateData.pinDamageDetails.errorText !== ''}"
                      class="form-control"
                      placeholder="Pin Damage Details*"
                    />
                </float-label>
                <span class="error-text" v-if="pinDamageDetailUpdateData.pinDamageDetails.errorText !== ''">
                    {{pinDamageDetailUpdateData.pinDamageDetails.errorText}}</span>
            </div>
        </div>
        <!--Pin Damage Details* ends-->
      </div>
    </div>
    </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import functions from "@/../../masters/functions.js";
import base from "@/../../masters/base.js";
import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
import vSelect from "vue-select";
import { reactive, onUpdated } from "@vue/composition-api";
export default {
  name: "PinDamageDetailUpdate",
  props: ["pinDamageDetailUpdateData"],
  components: {
    FloatLabel,
    Datepicker
  },
  setup(props, context) {
    let state = reactive({});
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const isFloat = functions.isFloat;

    onUpdated(()=>{
      let progressStep = 0;
      Object.values(props.pinDamageDetailUpdateData).forEach(obj => {
        if(obj.stepsMandatory){
          if(obj.value && !obj.errorText){
            progressStep++;
          }
        }
      })
      context.parent.updateSteps(progressStep);
      context.parent.enableCalculatePremiumBtn('pinDamageDetail');
    })
    return {
      state,
      isFloat,
      checkError,
      isInputError
    };
  },
   directives: {
    evolvews: functions.evolvews
  }
};
</script>
